/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcGenerateV1MonthlyStatementsTaskEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_GENERATE_V1_MONTHLY_STATEMENTS_TASK_EVENT_ENTITY_NAME = 'ixc.generate.v1.MonthlyStatementsTaskEvent';
export const ixcGenerateV1MonthlyStatementsTaskEventEntity = new schema.Entity<IxcGenerateV1MonthlyStatementsTaskEvent>(IXC_GENERATE_V1_MONTHLY_STATEMENTS_TASK_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxcGenerateV1MonthlyStatementsTaskEvent) => `${entity.metadata?.eventId}` });

